module.exports = new __parcel__URL__("micActive.edaf1b60.svg").toString();